
interface DashboardPeriodMetricProps {
  period: string;
  prevPeriod?: string;
  value: number;
  change: number;
}

export const DashboardPeriodMetric = ({
  period,
  prevPeriod,
  value,
  change,
}: DashboardPeriodMetricProps) => {

  const isDecrease = change < 0;
  const isNeutral = change == 0;

  // Format percentage to show "0%" instead of "+0%" or "-0%"
  const formattedPercentage = isNeutral ? "0%" : `${change}%`;

  return (
    <div className="bg-white p-3 sm:p-4 rounded-lg border">

      <div className="text-xl sm:text-2xl font-bold text-black">
        {(value || 0) > 0 ? '+' + (value || 0) : (value || 0)}
      </div>
      <p className="text-xs sm:text-sm text-gray-500 mb-4">reviews for {period}</p>
      <hr className="border-gray-200 mb-3" />
      <div className="flex items-center gap-1">
        <span className={isNeutral ? "text-[#A77A00]" : isDecrease ? "text-red-500" : "text-green-500"}>
          {isNeutral ? "-" : isDecrease ? "↘" : "↗"}
        </span>
        <span className={`text-xs sm:text-sm ${isNeutral ? "text-[#A77A00]" : isDecrease ? "text-red-500" : "text-green-500"}`}>
          {formattedPercentage}
        </span>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        compared to the previous { prevPeriod ?? period}
      </p>
    </div>
  );
};
